import { render, staticRenderFns } from "./Questions-demo.vue?vue&type=template&id=b0ae5b72"
import script from "./Questions-demo.vue?vue&type=script&lang=js"
export * from "./Questions-demo.vue?vue&type=script&lang=js"
import style0 from "./Questions-demo.vue?vue&type=style&index=0&id=b0ae5b72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports